__turbopack_context__.v({
  "border": "BasicTopNavigation-module-scss-module__IWEAKG__border",
  "center": "BasicTopNavigation-module-scss-module__IWEAKG__center",
  "fixed_width": "BasicTopNavigation-module-scss-module__IWEAKG__fixed_width",
  "inner_wrap": "BasicTopNavigation-module-scss-module__IWEAKG__inner_wrap",
  "left": "BasicTopNavigation-module-scss-module__IWEAKG__left",
  "right": "BasicTopNavigation-module-scss-module__IWEAKG__right",
  "text_button": "BasicTopNavigation-module-scss-module__IWEAKG__text_button",
  "title": "BasicTopNavigation-module-scss-module__IWEAKG__title",
  "title_button": "BasicTopNavigation-module-scss-module__IWEAKG__title_button",
  "title_text": "BasicTopNavigation-module-scss-module__IWEAKG__title_text",
  "wrap": "BasicTopNavigation-module-scss-module__IWEAKG__wrap",
});
